import { Page } from "@/components/Reveal";
import SiteEnd from "@/components/SiteEnd";

const sections = [
  {
    heading: "1. Acceptance of Terms",
    body: "By accessing or using the OPHO Digital website and services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our services.",
  },
  {
    heading: "2. Services",
    body: "OPHO Digital provides digital marketing, content strategy, SEO, performance advertising, and related services. The scope of work for each engagement is defined in a separate service agreement or proposal signed between OPHO Digital and the client.",
  },
  {
    heading: "3. Intellectual Property",
    body: "All content, branding, copy, designs, and materials created by OPHO Digital remain the intellectual property of OPHO Digital until full payment is received, at which point ownership transfers to the client as specified in the applicable service agreement. Our website content, logo, and brand assets are proprietary to OPHO Digital and may not be reproduced without written permission.",
  },
  {
    heading: "4. Confidentiality",
    body: "Both parties agree to keep confidential any proprietary information shared during the course of the engagement. This includes but is not limited to business strategies, financial data, client lists, and campaign performance metrics.",
  },
  {
    heading: "5. Payment Terms",
    body: "Payment terms are defined in individual client agreements. Late payments may result in a pause in services. OPHO Digital reserves the right to terminate an engagement if outstanding invoices remain unpaid beyond the agreed grace period.",
  },
  {
    heading: "6. Limitation of Liability",
    body: "OPHO Digital is not liable for indirect, incidental, or consequential damages arising from the use of our services. Our total liability to any client shall not exceed the total fees paid for the specific service giving rise to the claim in the three months preceding the event.",
  },
  {
    heading: "7. No Guarantee of Results",
    body: "While OPHO Digital uses industry best practices and data-driven strategies, we do not guarantee specific business outcomes such as revenue growth, lead volume, or search ranking positions. Marketing results depend on many factors outside our direct control.",
  },
  {
    heading: "8. Termination",
    body: "Either party may terminate services with written notice as specified in the applicable service agreement. Upon termination, the client is responsible for fees incurred up to the termination date.",
  },
  {
    heading: "9. Governing Law",
    body: "These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Mumbai, Maharashtra.",
  },
  {
    heading: "10. Changes to These Terms",
    body: "OPHO Digital reserves the right to update these Terms and Conditions at any time. Continued use of our services after changes are posted constitutes acceptance of the updated terms. We encourage you to review this page periodically.",
  },
];

export default function Terms() {
  return (
    <Page testId="terms-page">
      {/* Hero with blob+waves background, no globe/dash */}
      <div className="relative pt-28 sm:pt-32 pb-10 overflow-x-clip">
        <img src="/assets/blob.png" className="absolute -top-40 left-1/2 -translate-x-1/2 w-[110%] max-w-none opacity-70 pointer-events-none select-none" alt="" />
        <img src="/assets/waves.png" className="absolute top-[30px] sm:top-[60px] left-1/2 -translate-x-1/2 w-[118%] max-w-none pointer-events-none select-none" alt="" />
        <div className="relative site-container">
          <div className="flex items-end justify-between gap-8 sm:gap-16">
            <h1 data-testid="terms-page-heading" className="text-[40px] sm:text-[52px] lg:text-[64px] font-medium leading-[1.1] tracking-[-0.03em] text-[#111]">
              Terms &amp; Conditions.
            </h1>
            <span className="text-base sm:text-xl font-medium text-black/70 shrink-0 self-end pb-1">August 2026</span>
          </div>
        </div>
      </div>
      <section className="relative z-10 w-full px-6 mt-1">
        <div className="glass-surface relative rounded-[32px] px-6 sm:px-16 lg:px-[92px] py-16 lg:py-24 overflow-hidden">
          <div className="max-w-[758px]">
            <p className="text-base leading-relaxed text-[#111]/60">
              Please read these Terms and Conditions carefully before using the OPHO Digital website or engaging our services.
            </p>

            <div className="mt-10 space-y-10">
              {sections.map((s) => (
                <div key={s.heading}>
                  <h2 className="text-xl sm:text-2xl font-semibold text-[#111] tracking-tight">{s.heading}</h2>
                  <p className="mt-2 text-base leading-relaxed text-[#111]/60">{s.body}</p>
                </div>
              ))}

              <div>
                <h2 className="text-xl sm:text-2xl font-semibold text-[#111] tracking-tight">11. Contact</h2>
                <p className="mt-2 text-base leading-relaxed text-[#111]/60">
                  For questions about these Terms and Conditions, please contact us at{" "}
                  <a href="mailto:info@ophodigital.com" className="text-[#8C5EBA] hover:underline">
                    info@ophodigital.com
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SiteEnd />
    </Page>
  );
}
